import type { CSSProperties } from 'react';

const FALLBACK = '#8e8e93';

const DARK_TEXT = '#1c1c1e';
const LIGHT_TEXT = '#ffffff';

function parseHex(hex: string): { r: number; g: number; b: number } | null {
  if (!/^#[0-9a-fA-F]{6}$/.test(hex)) return null;
  return {
    r: parseInt(hex.slice(1, 3), 16),
    g: parseInt(hex.slice(3, 5), 16),
    b: parseInt(hex.slice(5, 7), 16),
  };
}

function linearize(channel8Bit: number): number {
  const c = channel8Bit / 255;
  return c <= 0.03928 ? c / 12.92 : ((c + 0.055) / 1.055) ** 2.4;
}

export function readableTextColor(hex: string): string {
  const rgb = parseHex(hex);
  if (!rgb) return LIGHT_TEXT;
  const luminance =
    0.2126 * linearize(rgb.r) + 0.7152 * linearize(rgb.g) + 0.0722 * linearize(rgb.b);
  return luminance > 0.45 ? DARK_TEXT : LIGHT_TEXT;
}

export function safeLabelColor(hex: string): string {
  return parseHex(hex) ? hex : FALLBACK;
}

export function labelChipStyle(hex: string, on: boolean): CSSProperties {
  const color = safeLabelColor(hex);
  return on
    ? { background: color, borderColor: color, color: readableTextColor(color) }
    : { background: 'transparent', borderColor: color };
}
